import React from 'react';

const LockIconSVG = () => (
    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 7.76465H13V5.76465C13 3.00465 10.76 0.764648 8 0.764648C5.24 0.764648 3 3.00465 3 5.76465V7.76465H2C0.9 7.76465 0 8.66465 0 9.76465V19.7646C0 20.8646 0.9 21.7646 2 21.7646H14C15.1 21.7646 16 20.8646 16 19.7646V9.76465C16 8.66465 15.1 7.76465 14 7.76465ZM5 5.76465C5 4.10465 6.34 2.76465 8 2.76465C9.66 2.76465 11 4.10465 11 5.76465V7.76465H5V5.76465ZM14 19.7646H2V9.76465H14V19.7646ZM8 16.7646C9.1 16.7646 10 15.8646 10 14.7646C10 13.6646 9.1 12.7646 8 12.7646C6.9 12.7646 6 13.6646 6 14.7646C6 15.8646 6.9 16.7646 8 16.7646Z" fill="#424242"/>
    </svg>
);

export default LockIconSVG;
